export const bounceIn = {
  0: {
    opacity: 0,
    scale: 0.3,
  },
  0.2: {
    scale: 1.1,
  },
  0.4: {
    scale: 0.9,
  },
  0.6: {
    opacity: 1,
    scale: 1.03,
  },
  0.8: {
    scale: 0.97,
  },
  1: {
    opacity: 1,
    scale: 1,
  },
};

export const bounceInUp = {
  0: {
    opacity: 0,
    translateY: 800,
  },
  0.6: {
    opacity: 1,
    translateY: -25,
  },
  0.75: {
    translateY: 10,
  },
  0.9: {
    translateY: -5,
  },
  1: {
    translateY: 0,
  },
};

export const bounceInDown = {
  0: {
    opacity: 0,
    translateY: -800,
  },
  0.6: {
    opacity: 1,
    translateY: 25,
  },
  0.75: {
    translateY: -10,
  },
  0.9: {
    translateY: 5,
  },
  1: {
    translateY: 0,
  },
};

export const bounceInRight = {
  0: {
    opacity: 0,
    translateX: 600,
  },
  0.6: {
    opacity: 1,
    translateX: -20,
  },
  0.75: {
    translateX: 8,
  },
  0.9: {
    translateX: -4,
  },
  1: {
    translateX: 0,
  },
};

export const bounceInLeft = {
  0: {
    opacity: 0,
    translateX: -600,
  },
  0.6: {
    opacity: 1,
    translateX: 20,
  },
  0.75: {
    translateX: -8,
  },
  0.9: {
    translateX: 4,
  },
  1: {
    translateX: 0,
  },
};
